export default __webpack_public_path__ + "static/media/Shape3.692be9c7.svg";